import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { ThemeProvider } from "@/components/ThemeProvider";
import { AuthProvider } from "@/contexts/AuthContext";
import { RouteGuard } from "@/components/RouteGuard";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/Sidebar";
import { Toaster } from "@/components/ui/sonner";
const queryClient = new QueryClient();

export const Route = createRootRouteWithContext()({
  component: () => (
    <div className="space-grotesk-light p-4 flex flex-row w-full h-full">
      <QueryClientProvider client={queryClient}>
        <ThemeProvider defaultTheme="light" storageKey="theme">
          <AuthProvider>
            <SidebarProvider>
              <RouteGuard>
                <AppSidebar />
                <SidebarTrigger />
                <Outlet />
                <Toaster />
                {/* <TanStackRouterDevtools /> */}
              </RouteGuard>
            </SidebarProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </div>
  ),
});
